module.exports = __webpack_public_path__ + "static/media/codeSara.251a93ca.gif";